import { default as Modal } from './AbstractModal';

export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = 'has-modal-open'

    constructor(m) {
        super(m);
    }

    ///////////////
    // Callbacks
    ///////////////
    onInit() {}

    onDestroy() {}

    setCloseLabel(closeLabel) {
        this.$('closeLabel')[0].innerHTML = closeLabel
    }

    setModifier(type) {
        if (this.modifier != null) {
            this.el.classList.remove(this.modifier)
        }

        this.modifier = '-' + type
        this.el.classList.add(this.modifier)
    }

    setAttributes(attributes) {
        const { type } = attributes
        let event

        console.log(type)

        switch (type) {
            case 'rsvp':
                event = new CustomEvent('updateFormRsvpAttributes', { detail: attributes });
                window.dispatchEvent(event);
                break
            case 'events':
                event = new CustomEvent('updateFormEventsAttributes', { detail: attributes });
                window.dispatchEvent(event);
                break
        }
    }

    onClose() {
        this.el.classList.remove('is-open')
    }

    onOpen(args) {
        requestAnimationFrame(() => {
            this.el.classList.add('is-open')
        })
    }
}
